import React from 'react'
import './couple.css'

const Theme2Photocouple = ({values}) => {

   const renderPersonCard = ({
    image,
    alt,
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    if (!image?.url) return null;

    const baseUrl = image.url;

    return (
      <div className="t2-preview-single-couple-container">

        <div className="t2-preview-couple-grandparents">
        {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
   </div>
          <img
            src={baseUrl}
            alt={alt}
            srcSet={`
              ${baseUrl.replace("/upload/", "/upload/w_320/")} 320w,
              ${baseUrl.replace("/upload/", "/upload/w_640/")} 640w,
              ${baseUrl.replace("/upload/", "/upload/w_1080/")} 1080w
            `}
            sizes="
              (max-width: 320px) 320px,
              (max-width: 640px) 640px,
              (max-width: 1080px) 1080px
            "
            className="t2-preview-couple-image"
          />

          <h1 className="t2-preview-couple-name">
            {fullname}
          </h1>

          <div className="t2-preview-couple-parents">
            {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
          </div>

       

      </div>
    );
  };

    const groomCard = () =>
    renderPersonCard({
      image: values.groomImage,
      alt: "groomImage",
      fullname: values.groomFullName || "Groom Full Name",
      parentprefix: values.groomParentsPrefix,
      parentsName: values.groomParents,
      grandParentsPrefix: values.groomGrandParentsPrefix,
      grandParentsName: values.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      image: values.brideImage,
      alt: "brideImage",
      fullname: values.brideFullName || "Bride Full Name",
      parentprefix: values.brideParentsPrefix,
      parentsName: values.brideParents,
      grandParentsPrefix: values.brideGrandParentsPrefix,
      grandParentsName: values.brideGrandParents,
    });



  return (
     <div className="t2-couple-section t2-photo-couple">
      <img src="/theme2coverAsset.png" className='t2-preview-couple-frame-border t2-preview-couple-frame-border-top ' alt="" />
            <img src="/theme2coverAsset.png" className='t2-preview-couple-frame-border  t2-preview-couple-frame-border-bottom' alt="" />
          <h1 className='t2-preview-couple-heading'>  {values?.sectionHeading}</h1>
           <div className="t2-preview-couple-wrapper">

                  {values.displayOrder==="groomFirst" ?(
                       <>
                         {groomCard()}

                           <span className="t2-preview-couple-divider">
                        &
                    </span>

                    {brideCard()}

                       </>
                  ):(
                          <>
                              {brideCard()}
                              

                           <span className="t2-preview-couple-divider">
                        &
                    </span>
                          {groomCard()}
                   
                          </>
                  )}
           </div>
     </div>
  )
}

export default Theme2Photocouple